{
	"titleFirstPart": "Benvenuto in",
	"titleSecondPart": "Heidelberg Materials {{productName}}",
	"totalCarbonStored": "Totale carbonio stoccato"
}
